<script>
    import { onMount } from 'svelte';
    import Modal from "../components/Modal.svelte";	
    import Modal_series from "../components/Modal_series.svelte";	
    import Modal_alta from "../components/Modal_alta.svelte";	
    import Top from "../components/top.svelte";	
    import { iddistribuidor, nombre } from '../store/distribuidor.js';
	import { jwt } from "../store/index.js";

    let actives = "pestaña3";
    let actives1 = "pestaña2"; 
    let actives2 = "pestaña2";
    let actives3 = "pestaña2";
    let show_a=true;
    let show_a1;
    let show_a2;
    let show_a3;
    let conceptosa = [];
    let modal_alta_servicio;
    let concepto_alta;
    let mensual_alta;
    let fijo_alta;
    async function alta_servicios(){
        try {
            const data = new FormData()
            data.append('concepto', concepto_alta);
            data.append('mensual', mensual_alta);
            data.append('fijo', fijo_alta);
            let res = await fetch('http://localhost/php/create-servicio.php', {
                method : "POST",
                body: data
            })
            console.log(res)
		    alert("creado con exito");
            const url1 = 'http://localhost/php/get-conceptos.php';
            let resa = await fetch(url1)
            resa = await resa.json()
            conceptosa = resa.data;
            console.log(resa.data)
            modal_alta_servicio.hide();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
    }
    onMount(async () => {
        const url1 = 'http://localhost/php/get-conceptos-venta.php';
        let resa = await fetch(url1)
        resa = await resa.json()
        conceptosa = resa.data;
        console.log(resa.data)
    })

    async function eliminar_servicio(i){
        idservicio = conceptosa[i].idservicio;
        let r2 = window.confirm("¿Desea eliminar el servicio " + conceptosa[i].Concepto + "?");
        if (r2 == true) {
            try {
            const data = new FormData()
            data.append('id', idservicio);
            let res = await fetch('http://localhost/php/delete-servicio.php', {
                method : "POST",
                body: data
            })
            console.log(res)
            alert("Eliminado con exito");
            const url1 = 'http://localhost/php/get-conceptos.php';
            let resa = await fetch(url1)
            resa = await resa.json()
            conceptosa = resa.data;
            console.log(resa.data)
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
        }
      }
    function showa(){
		show_a = true;
		show_a1 = false;
		show_a2 = false;
        show_a3 = false;
        actives="pestaña3";
        actives1="pestaña2";
        actives2="pestaña2";
        actives3="pestaña2";
	}
    function showa1(){
		show_a = false;
		show_a1 = true;
		show_a2 = false;
        show_a3 = false;
        actives="pestaña2";
        actives1="pestaña3";
        actives2="pestaña2";
        actives3="pestaña2";
	}
    function showa2(){
		show_a = false;
		show_a1 = false;
		show_a2 = true;
        show_a3 = false;
        actives="pestaña2";
        actives1="pestaña2";
        actives2="pestaña3";
        actives3="pestaña2";
	}
    function showa3(){
		show_a = false;
		show_a1 = false;
		show_a2 = false;
        show_a3 = true;
        actives="pestaña2";
        actives1="pestaña2";
        actives2="pestaña2";
        actives3="pestaña3";
	}
</script>
<Top/>
<div class="conten_conceptos">
    <div class="cabecera_modal">
        <div class="row1">
            <div class="{actives}" on:click={showa}>
                <h4>Base modules</h4>
            </div>
            <div class="{actives1}" on:click={showa1}>
                <h4>Distributor modules</h4>
            </div>
            <div class="{actives2}" on:click={showa2}>
                <h4>Websites</h4>
            </div>
            <div class="{actives3}" on:click={showa3}>
                <h4>Apps</h4>
            </div>
        </div>
    </div>
    <div>
        {#if show_a}
        <div class="tabla_servicios">
            <table>
                <thead>
                    <th class="column">Concept</th>
                    <th class="column1">Monthly payment</th>
                    <th class="column2">License acquisition</th>
                </thead>
                <tbody>
                    {#each conceptosa as conceptos, i}
                        {#if conceptos.Tipo == "Modulo base"}
                            <tr>
                                <td class="column">{conceptos.Concepto}</td>
                                {#if conceptos.Precio_mensual != "0.00"}
                                    <td class="column1">$ {conceptos.Precio_mensual}</td>
                                {:else}
                                    <td class="column1">Free</td>
                                {/if}
                                
                                {#if conceptos.Precio_fijo != "0.00"}
                                    <td class="column2">$ {conceptos.Precio_fijo}</td>
                                {:else}
                                    <td class="column2">Not available</td>
                                {/if}
                            </tr>
                        {/if}
                    {/each}
                </tbody>
            </table>
        </div>
        {/if}
        {#if show_a1}  
        <div class="tabla_servicios">
            <table>
                <thead>
                    <th class="column">Concept</th>
                    <th class="column1">Monthly payment</th>
                    <th class="column2">License acquisition</th>
                    <th class="column3" on:click={() => modal_alta_servicio.show()}> <img src="./img/mas.svg" alt=""></th>
                </thead>
                <tbody>
                    {#each conceptosa as conceptos, i}
                        {#if conceptos.Tipo == "Modulo distribuidor"}
                            <tr>
                                <td class="column">{conceptos.Concepto}</td>
                                {#if conceptos.Precio_mensual != "0.00"}
                                    <td class="column1">$ {conceptos.Precio_mensual}</td>
                                {:else}
                                    <td class="column1">Not available</td>
                                {/if}
                                
                                {#if conceptos.Precio_fijo != "0.00"}
                                    <td class="column2">$ {conceptos.Precio_fijo}</td>
                                {:else}
                                    <td class="column2">Not available</td>
                                {/if}
                                <td class="column3" on:click={() => eliminar_servicio(i)}><img src="./img/menos.svg" alt=""></td>
                            </tr>
                        {/if}
                    {/each}
                </tbody>
            </table>
        </div>
        {/if}
        {#if show_a2}
        <div class="tabla_servicios">
            <table>
                <thead>
                    <th class="column">Concept</th>
                    <th class="column1">Monthly payment</th>
                    <th class="column2">License acquisition</th>
                </thead>
                <tbody>
                    {#each conceptosa as conceptos, i}
                        {#if conceptos.Tipo == "WEB"}
                            <tr>
                                <td class="column">{conceptos.Concepto}</td>
                                {#if conceptos.Precio_mensual != "0.00"}
                                    <td class="column1">$ {conceptos.Precio_mensual}</td>
                                {:else}
                                    <td class="column1">Not available</td>
                                {/if}
                                
                                {#if conceptos.Precio_fijo != "0.00"}
                                    <td class="column2">$ {conceptos.Precio_fijo}</td>
                                {:else}
                                    <td class="column2">Not available</td>
                                {/if}
                            </tr>
                        {/if}
                    {/each}
                </tbody>
            </table>
        </div>
        {/if}
        {#if show_a3}
        <div class="tabla_servicios">
            <table>
                <thead>
                    <th class="column">Concept</th>
                    <th class="column1">Monthly payment</th>
                    <th class="column2">License acquisition</th>
                </thead>
                <tbody>
                    {#each conceptosa as conceptos, i}
                        {#if conceptos.Tipo == "App"}
                            <tr>
                                <td class="column">{conceptos.Concepto}</td>
                                {#if conceptos.Precio_mensual != "0.00"}
                                    <td class="column1">$ {conceptos.Precio_mensual}</td>
                                {:else}
                                    <td class="column1">Not available</td>
                                {/if}
                                
                                {#if conceptos.Precio_fijo != "0.00"}
                                    <td class="column2">$ {conceptos.Precio_fijo}</td>
                                {:else}
                                    <td class="column2">Not available</td>
                                {/if}
                            </tr>
                        {/if}
                    {/each}
                </tbody>
            </table>
        </div>
        {/if}
    </div>
</div>
<Modal_alta bind:this={modal_alta_servicio}>
    <form on:submit|preventDefault={alta_servicios}>
        <h2 class="titulo-modal">New module</h2>
        <h4 class="texto_modal">Concept</h4>
        <input type="text" class="input_modal" bind:value={concepto_alta} required>
        <h4 class="texto_modal">Monthly price</h4>
        <input type="text" class="input_modal" bind:value={mensual_alta} required>
        <h4 class="texto_modal">fixed price</h4>
        <input type="text" class="input_modal" bind:value={fijo_alta}>
        <button class="modal_button" type="submit">save</button>
    </form>
</Modal_alta>